<template>
  <!-- :style="{ height: getVariableTableHeight }" -->
  <div
    id="custom-table-wrap-id"
    class="custom-table-wrap fancy-scroll"
    :class="{
      'hide-scrollbar': isEnableDirectEditing,
    }"
    :style="{ maxHeight: getVariableTableHeight }"
    @scroll="onWrapScroll"
    @wheel="onMouseWheel"
    :ref="'tableWrapRef' + tableid"
    @drag="handleDragMove"
  >
    <table
      class="table custom-table"
      :id="tableid"
      v-if="dataHeader.length > 0 && dataList.length > 0"
    >
      <thead>
        <draggable
          v-model="headers"
          tag="tr"
          :move="handleMove"
          @end="handleDragEnd"
          ghost-class="ghost"
          draggable=".draggableitems"
          handle=".hoveritem"
          @start="onDragStart"
        >
          <th class="check-box">
            <div class="checker">
              <input
                type="checkbox"
                :checked="isAllItemSelected"
                @change="onCheckAllBox"
              />
            </div>
          </th>
          <th
            v-for="(header, i) in headers"
            :key="header + 'th-headers' + i"
            :id="header"
            :style="getColumnStyle(header)"
            @dragover="dragEnterHandler"
            @dragleave="dragLeaveHandler"
            class="draggableitems"
            scope="custom-table"
          >
            <div class="resizeHandle-before"></div>
            <span
              class="hoveritem"
              @mouseenter="onMouseEnterOnTableHeader"
              @mouseleave="onMouseLeaveOnTableHeader"
            >
              {{ getHeader(header) }}
            </span>
            <div
              @dblclick="handleResizeDoubleClick(header)"
              class="resizeHandle"
            ></div>
          </th>
          <th id="table-header-created">
            <span class="hoveritem">Erstellt am</span>
          </th>
        </draggable>
      </thead>
      <tbody>
        <div
          :style="{
            height: spacerHeight.top + 'px',
          }"
        ></div>
        <tr
          v-for="(item, index) in getVisibleItems"
          :ref="`tablerow${index}`"
          :key="item.name + 'tr-body-row' + index"
          @mouseenter="getPositionForActionBar(index)"
          @mouseleave="onTrMouseOut(index)"
          :class="
            getRowCheckedClasses(
              getVisibleItems[index - 1],
              item,
              getVisibleItems[index + 1]
            )
          "
          @click="onTrClick($event)"
          class="table-row shadow-visible"
        >
          <td class="check-box">
            <div class="checker">
              <input
                type="checkbox"
                @click="onCheckBoxClick($event, item)"
                :checked="isCheckboxChecked(item)"
              />
            </div>
          </td>
          <template v-for="(header, i) in headers">
            <td
              :class="{
                'list-item-td':
                  isList(item[header]) &&
                  !isCorrectElementType(header, 'checkbox'),
              }"
            >
              <div
                v-if="isCorrectElementType(header, 'linktodb')"
                class="table-content"
                @click="
                  showEditInputField(
                    $event,
                    header,
                    item[header],
                    item.id,
                    'linktodb'
                  )
                "
              >
                <div
                  class="d-inline"
                  @click="onLinkCellContentClick($event, header, item)"
                  v-html="getLinkHtml(header, item)"
                ></div>
              </div>
              <div
                class="formatted-number-wrapper"
                v-else-if="isCorrectElementType(header, 'formatted_number')"
                @click="
                  showEditInputField(
                    $event,
                    header,
                    item[header],
                    item.id,
                    'formatted_number'
                  )
                "
              >
                <NumberComponent
                  :passedNumberValue="item[header]"
                  :decimalValuesCount="
                    getFormattedElementToFixedValue(header, 'formatted_number')
                  "
                  :showAsFixedNumber="true"
                  :isContentAlignedToEnd="true"
                  :formatNumber="getFormatNumber(header)"
                />
              </div>
              <div v-else-if="isCorrectElementType(header, 'freecontent')">
                <img
                  class="object-list-icon"
                  src="../assets/img/object-list.svg"
                  alt="list"
                />
              </div>
              <div
                v-else-if="isCorrectElementType(header, 'timestampms')"
                class="table-content"
                @click="
                  showEditInputField(
                    $event,
                    header,
                    item[header],
                    item.id,
                    'timestampms'
                  )
                "
              >
                {{ item[header] ? formatDate(item[header]) : null }}
              </div>
              <div
                v-else-if="
                  isList(item[header]) &&
                  !isCorrectElementType(header, 'checkbox') &&
                  isCorrectElementType(header, 'objectlist')
                "
                class="list"
              >
                <div
                  @mouseover="onListImageHover($event, header, index, true)"
                  @mouseleave="onListImageHover($event, header, index, false)"
                  class="list-main"
                  v-if="item[header].length"
                >
                  {{ getListContent(item[header], header) }}
                </div>
                <div
                  class="list-content-wrapper"
                  :id="`list-content-${header}-${index}`"
                  v-if="item[header].length && !isScrolling"
                >
                  <div
                    @scroll.passive="showScrollbar"
                    class="list-scroll fancy-scroll"
                  >
                    <div
                      class="list-content-main"
                      v-for="(objectList, index) in item[header]"
                      :key="`list-${header}-${index}`"
                    >
                      <div class="one-list-wrapper">
                        <div
                          v-for="(objectListContent, key) in validateIterable(
                            objectList
                          )"
                          :key="`item-${key}-${header}-${index}`"
                        >
                          <div
                            v-if="
                              getObjectListLabel(
                                header,
                                key,
                                objectListContent,
                                false,
                                false,
                                true
                              )
                            "
                            class="list-content"
                            v-html="
                              getObjectListLabel(
                                header,
                                key,
                                objectListContent,
                                false,
                                false,
                                true
                              )
                            "
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-else-if="isCorrectElementType(header, 'text')"
                class="table-content"
                @click="
                  showEditInputField(
                    $event,
                    header,
                    item[header],
                    item.id,
                    'text'
                  )
                "
              >
                {{ item[header] }}
              </div>
              <div
                v-else-if="isCorrectElementType(header, 'select')"
                @click="
                  showEditInputField(
                    $event,
                    header,
                    item[header],
                    item.id,
                    'select'
                  )
                "
                class="table-content"
              >
                {{ getDropdownLabel(header, item[header]) }}
              </div>

              <div
                v-else-if="isCorrectElementType(header, 'radio')"
                @click="
                  showEditInputField($event, header, item[header], item.id)
                "
                class="table-content"
              >
                {{ getRadioLabel(header, item[header]) }}
              </div>
              <div
                v-else-if="isCorrectElementType(header, 'checkbox')"
                class="table-content"
                @click="
                  showEditInputField($event, header, item[header], item.id)
                "
              >
                {{ getCheckboxLabel(header, item[header]) }}
              </div>
              <div
                @mouseenter="showTextAreaPopup($event, item[header])"
                @mouseleave="hideTextAreaPopup"
                v-else-if="isCorrectElementType(header, 'textarea')"
                class="table-content"
                @click="
                  showEditInputField($event, header, item[header], item.id)
                "
              >
                {{ formatValues(item[header]) }}
              </div>
              <div
                v-else
                class="table-content"
                @click="
                  showEditInputField($event, header, item[header], item.id)
                "
              >
                {{ formatValues(item[header]) }}
              </div>
            </td>
          </template>

          <td
            class="table-column-created"
            v-if="
              item.hasOwnProperty(getSqlKey('created')) &&
              item[getSqlKey('created')] != null
            "
          >
            <div class="table-content">
              {{ getFormattedDate(item) }}
            </div>
          </td>
          <td v-if="inlineView" class="blank_column"></td>
          <div v-if="item.loading" class="row-loader-div-wrap loadingoverlay">
            <div
              class="row-loader-div"
              :style="{ 'max-width': tableWrapWidth + 'px' }"
            >
              <div class="custom-table-progress-icon"></div>
            </div>
          </div>
          <div class="shadow-div-wrap">
            <div
              id="actionToolbarWrapper"
              class="table-action-tools"
              :style="{
                top: actionTop + 10 + 'px',
                right: actionRight + 'px',
              }"
              v-if="!databaseLinkedViewScrolling && !isScrolling"
            >
              <slot
                :loopitems="{
                  item,
                  index,
                  onDropdownOpen,
                  onDropdownClose,
                }"
              ></slot>
            </div>
          </div>
        </tr>
        <div
          :style="{
            height: spacerHeight.bottom + 'px',
          }"
        ></div>
      </tbody>
    </table>

    <div
      v-if="textAreaPopup.visible && !isScrolling"
      class="textarea-popup"
      :style="textAreaPopup.style"
    >
      {{ textAreaPopup.text }}
    </div>
    <slot name="loadmore"></slot>
    <template v-for="(element, i) in directEditInput.inputs">
      <DirectEditInput
        v-if="element.show"
        :key="i"
        :directEditInput="element"
        :getFormattedElementToFixedValue="getFormattedElementToFixedValue"
        :getFormatNumber="getFormatNumber"
        :database="database"
        @hideEditInputField="hideEditInputField"
        :ref="`direct-edit-input-${element.uuid}`"
      />
    </template>
  </div>
</template>
<script>
import draggable from 'vuedraggable';
import {
  isObjectType,
  debouncer,
  getPreSignedUrl,
  uploadFile,
  generateUUID,
  validateIterable,
} from '../utils/helpers';
import NumberComponent from './widgets/NumberComponent.vue';
import moment from 'moment';
import DirectEditInput from './DirectEditInput.vue';
import { updateOneItemField } from '../services/customdb.service';
import { mapGetters } from 'vuex';
export default {
  name: 'CustomTable',
  data() {
    return {
      headers: [],
      columnWidth: this.colWidth,
      futureIndex: null,
      movingIndex: null,
      scrollDirection: null,
      scrollAnimation: null,
      tableWrapWidth: 0,
      isDragging: false,
      actionTop: 350,
      isScrolling: false,
      scrollTimeout: null,
      isColumnResizing: false,
      databaseLinkedViewScrolling: false,
      startX: 0,
      currentMousePosition: {
        x: 0,
        y: 0,
      },
      virtualScrollData: {
        startIndex: 0,
        endIndex: 10, // Adjust this value based on how many rows you want to display initially
        itemHeight: 50, // Adjust this value to match your row height
        visibleItemsCount: 10, // Adjust this value to control how many items are visible
      },
      movingItemRect: {},
      actionRight: 54,
      directEditInput: {
        inputs: [],
      },
      textAreaPopup: {
        visible: false,
        text: '',
        style: {},
      },
    };
  },
  props: {
    inlineView: {
      type: Boolean,
      required: false,
      default: false,
    },
    tableid: {
      type: String,
      required: true,
    },
    dataHeader: {
      type: Array,
      required: true,
      default: () => [],
    },
    dataList: {
      type: Array,
      required: true,
    },
    colWidth: {
      type: Object,
      required: true,
    },
    isCheckBoxEnabled: {
      type: Boolean,
      required: true,
    },
    isCheckboxChecked: {
      type: Function,
      required: true,
    },
    getSqlKey: {
      type: Function,
      required: true,
    },
    getHeaderContent: {
      type: Object,
      required: false,
    },
    variableTableHeight: {
      type: Number,
      required: false,
    },
    isCorrectElementType: {
      type: Function,
      required: true,
      default: () => {},
    },
    generateLink: {
      type: Function,
      required: true,
      default: () => {},
    },

    getFormattedElementToFixedValue: {
      type: Function,
      required: false,
      default: () => {},
    },
    getObjectData: {
      type: Function,
      required: false,
      default: () => {},
    },
    database: {
      type: Object,
      required: true,
    },
    isAllItemSelected: {
      type: Boolean,
    },
  },
  methods: {
    validateIterable,
    onLinkCellContentClick(event, header, item) {
      if (this.hasLinkCellValue(header, item)) {
        event.stopPropagation();
      }
    },
    hasLinkCellValue(header, item) {
      if (!item || !Object.prototype.hasOwnProperty.call(item, header)) {
        return false;
      }
      const value = item[header];
      return !(value === undefined || value === null || value === '');
    },
    getLinkHtml(header, item) {
      if (!this.hasLinkCellValue(header, item)) {
        return '';
      }
      return this.generateLink(header, item[header]);
    },
    onListImageHover(e, header, index, isShow) {
      const mainRowElement = e.target.parentElement.parentElement.parentElement;
      const actionToolbar = mainRowElement.querySelector(
        '#actionToolbarWrapper'
      );
      let showListContentOnHover;
      if (actionToolbar) {
        const coordinates = actionToolbar.getClientRects()[0];
        if (e.clientX > coordinates.x) {
          showListContentOnHover = false;
        } else {
          showListContentOnHover = true;
        }
      }
      const listContent = document.getElementById(
        `list-content-${header}-${index}`
      );
      if (listContent && !this.isScrolling) {
        const getCoordinates = e.target.getClientRects()[0];
        if (isShow && showListContentOnHover) {
          listContent.style.display = 'block';
          const listContentHeight = listContent.offsetHeight;
          let calculatedTop;
          if (window.innerHeight - getCoordinates.bottom < listContentHeight) {
            calculatedTop = getCoordinates.top - listContentHeight;
          } else {
            calculatedTop = getCoordinates.top + 50;
          }

          const tableWrap = this.$refs[`tableWrapRef${this.tableid}`];
          const stickyHeader = tableWrap?.querySelector('thead');
          if (stickyHeader) {
            const headerBottom = stickyHeader.getBoundingClientRect().bottom;
            const safeTop = headerBottom + 8;
            calculatedTop = Math.max(calculatedTop, safeTop);
          }
          listContent.style.top = `${calculatedTop}px`;

          const td = e.target.closest('td');
          if (!td) return;

          const { left: tdLeft, width: tdWidth } = td.getBoundingClientRect();
          const floatWidth = 367;
          const offset = -70;

          let left =
            tdWidth >= floatWidth
              ? tdLeft + (tdWidth - floatWidth) / 2
              : e.screenX;

          left += offset;

          const margin = 8;
          left = Math.max(
            margin,
            Math.min(left, window.innerWidth - floatWidth - margin)
          );

          listContent.style.left = `${left + 70}px`;
          if (listContentHeight >= 259) {
            listContent.classList.add('list-border');
          }
        } else {
          listContent.style.display = 'none';
        }
      }
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
    isDropDownOpenInContainer() {
      const tableWrap = this.$refs[`tableWrapRef${this.tableid}`];
      if (tableWrap) {
        const isDropDownOpen = tableWrap.querySelector(
          '.dropdown.b-dropdown.dropdown-component.show'
        );
        return { isDropDownOpen, tableWrap };
      } else {
        return { isDropDownOpen: null, tableWrap: null };
      }
    },
    onTrClick(event) {
      const currentTR = event.currentTarget;
      const { isDropDownOpen, tableWrap } = this.isDropDownOpenInContainer();

      if (isDropDownOpen === null) return;

      const parentTr = isDropDownOpen.closest('tr');

      if (parentTr && parentTr !== currentTR) {
        this.hideActionBar(parentTr);
        currentTR.classList.remove('hide-action-bar');
        const trRect = currentTR.getBoundingClientRect();
        if (!this.isElementVisibleInViewport(currentTR, tableWrap)) {
          currentTR.classList.add('hide-action-bar');
        }

        if (trRect) {
          this.actionTop = trRect.top;
        }

        this.showActionBar(currentTR);
      }
    },

    onDropdownOpen(e, index) {
      const tr = this.$refs[`tablerow${index}`][0];
      if (tr) {
        tr.style.zIndex = '1002';
      }
    },
    onDropdownClose(e, index) {
      const tr = this.$refs[`tablerow${index}`][0];
      if (tr) {
        tr.style.zIndex = '';
      }
    },
    onDragStart(e) {
      this.isDragging = true;
      this.startSmoothScroll();
      this.$refs[`tableWrapRef${this.tableid}`].style.overflowY = 'hidden';
      this.startX = e.originalEvent.clientX;
      this.currentMousePosition = {
        x: 0,
        y: 0,
      };
    },
    onTrMouseOut(index) {
      const tr = this.$refs[`tablerow${index}`][0];

      if (tr) {
        this.$emit('onTrMouseLeave', index, tr);
        if (this.isDropDownOpenInContainer().isDropDownOpen === null) {
          this.hideActionBar(tr);
          tr.style.zIndex = '';
        }
      }
    },
    onWrapScroll(event) {
      const scrollTop = event.target.scrollTop;
      const newStart = Math.max(
        0,
        Math.floor(scrollTop / this.virtualScrollData.itemHeight)
      );
      const newEnd = newStart + this.virtualScrollData.visibleItemsCount;
      if (
        newStart !== this.virtualScrollData.startIndex ||
        newEnd !== this.virtualScrollData.endIndex
      ) {
        this.virtualScrollData.startIndex = newStart;
        this.virtualScrollData.endIndex = newEnd;
      }
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
      this.hideTextAreaPopup();
      this.isScrolling = true;
      let scrollTimer;

      window.clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        this.isScrolling = false;
      }, 400);

      this.hideDropDown();
    },
    onMouseWheel(event) {
      if (this.isEnableDirectEditing) {
        event.stopPropagation();
        event.preventDefault();
      }
    },
    onDatabaseLinkedViewScroll() {
      this.hideDropDown();
      this.databaseLinkedViewScrolling = true;
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      } else {
        this.databaseLinkedViewScrolling = true;
      }
      this.scrollTimeout = setTimeout(() => {
        this.databaseLinkedViewScrolling = false;
        this.scrollTimeout = null;
      }, 0);
    },
    hideDropDown() {
      const { isDropDownOpen } = this.isDropDownOpenInContainer();

      if (isDropDownOpen === null) return;

      const toggleButton = isDropDownOpen.querySelector('.dropdown-toggle');

      if (toggleButton) {
        toggleButton.click();
      }
    },
    isElementVisibleInViewport(el, container) {
      const headerHeight = document
        .getElementById(this.tableid)
        .querySelector('thead').offsetHeight;
      const containerRect = container.getBoundingClientRect();
      const elementRect = el.getBoundingClientRect();
      const containerTop = containerRect.top + headerHeight;
      const elementTop = elementRect.top - containerTop;
      const elementBottom = elementRect.bottom - containerTop;
      const containerHeight = container.clientHeight - headerHeight;

      return elementTop >= 0 && elementBottom <= containerHeight;
    },
    getPositionForActionBar(e) {
      if (this.getsidebarLinkedCustomDBSettings) return;
      const { isDropDownOpen, tableWrap } = this.isDropDownOpenInContainer();

      if (isDropDownOpen === null) {
        const tr = this.$refs[`tablerow${e}`][0];
        tr.classList.remove('hide-action-bar');
        const trRect = tr.getBoundingClientRect();

        if (!this.isElementVisibleInViewport(tr, tableWrap)) {
          tr.classList.add('hide-action-bar');
          tr.classList.remove('shadow-visible');
          return;
        } else {
          tr.classList.add('shadow-visible');
        }

        if (trRect) {
          this.actionTop = trRect.top;
        }

        this.showActionBar(tr);
      }
    },
    showActionBar(row) {
      const actionBar = row.querySelector('#actionToolbarWrapper');
      if (actionBar && !this.isColumnResizing) {
        actionBar.style.opacity = '1';
        actionBar.style.visibility = 'visible';
        actionBar.style.pointerEvents = 'all';
        const tableWrapElement = this.$refs[`tableWrapRef${this.tableid}`];
        if (this.inlineView) {
          const scrollEndGap =
            tableWrapElement.scrollWidth -
            (tableWrapElement.scrollLeft + tableWrapElement.clientWidth);

          this.actionRight =
            tableWrapElement?.getBoundingClientRect()?.left +
            (scrollEndGap < 30 ? 32 - scrollEndGap : -3);
          return;
        }
        if (
          tableWrapElement &&
          tableWrapElement.clientWidth < tableWrapElement.scrollWidth
        ) {
          if (
            tableWrapElement.scrollLeft + tableWrapElement.clientWidth >=
            tableWrapElement.scrollWidth
          ) {
            this.actionRight = 54;
          } else {
            const mainWrapper = document.getElementById('custom-table-wrap-id');
            if (mainWrapper.scrollHeight > mainWrapper.clientHeight) {
              this.actionRight = 54;
            } else {
              this.actionRight = 32;
            }
          }
        } else {
          this.actionRight = 54;
        }
      }
    },
    hideActionBar(row) {
      if (this.getsidebarLinkedCustomDBSettings) return;
      const actionBar = row.querySelector('#actionToolbarWrapper');
      if (actionBar) {
        actionBar.style.opacity = '0';
        actionBar.style.visibility = 'hidden';
        actionBar.style.pointerEvents = 'none';
      }
    },
    getFormattedDate(item) {
      let date = moment(item[this.getSqlKey('created')]).format(
        this.isShowSeconds ? 'DD.MM.YYYY HH:mm:ss' : 'DD.MM.YYYY HH:mm'
      );
      return date ? date : '--';
    },
    getHeader(headerName) {
      if (this.getHeaderContent) {
        return this.getHeaderContent[headerName];
      } else {
        return headerName;
      }
    },
    onCheckBoxClick(event, item) {
      event.stopPropagation();
      this.$emit('onCheckBoxClick', event, item);
    },
    onCheckAllBox(event) {
      this.$emit('onCheckAllBox', event);
    },
    emitUpdateEvent() {
      this.$emit('onDragOrResize', {
        // updatedHeaders: this.headers,
        updatedHeaders: [...this.headers].filter(
          (el) => el !== null && el !== undefined
        ),
        updatedHeadersWidth: this.columnWidth,
      });
    },
    handleDragMove(event) {
      const tableRect =
        this.$refs[`tableWrapRef${this.tableid}`]?.getBoundingClientRect();

      if (!tableRect) return;
      if (
        event.clientX < tableRect.left ||
        event.clientX > tableRect.right ||
        event.clientY < tableRect.top ||
        event.clientY > tableRect.bottom
      ) {
        this.scrollDirection = null;
      } else {
        this.setScrollDirection(event);
      }
    },
    handleDragEnd(event) {
      this.isDragging = false;
      this.scrollDirection = null;
      cancelAnimationFrame(this.scrollAnimation);
      if (!this.currentMousePosition.x && !this.currentMousePosition.y) {
        this.currentMousePosition = {
          x: event.originalEvent.x,
          y: event.originalEvent.y,
        };
      }
      this.$refs[`tableWrapRef${this.tableid}`].style.overflowY = 'auto';
      const divs = document.getElementsByClassName('resizeHandle');
      const leftDiv = document.getElementsByClassName('resizeHandle-before');

      for (var i = 0; i < divs.length; i++) {
        divs[i].style.border = 'none';
        leftDiv[i].style.border = 'none';
      }

      if (this.futureIndex !== null && this.movingIndex !== null) {
        // this.futureItem = this.headers[this.futureIndex];
        // this.movingItem = this.headers[this.movingIndex];
        // const _items = Object.assign([], this.headers);
        // _items[this.futureIndex] = this.movingItem;
        // _items[this.movingIndex] = this.futureItem;
        // this.headers = _items;
        // this.emitUpdateEvent();

        // this.futureIndex = null;
        // this.movingIndex = null;

        // to check is element position changed or not start

        const currentdropPositionX = event.originalEvent.x;
        const currentdropPositionY = event.originalEvent.y;

        const isInsideNewItemRect =
          this.movingItemRect?.left < currentdropPositionX &&
          this.movingItemRect?.right > currentdropPositionX &&
          this.movingItemRect?.top < currentdropPositionY &&
          this.movingItemRect?.bottom > currentdropPositionY;

        if (!isInsideNewItemRect) {
          this.movingItemRect = {};
          this.movingIndex = null;
          return;
        }

        // to check is element position changed or not end

        this.futureItem = this.headers[this.futureIndex];
        this.movingItem = this.headers[this.movingIndex];

        const _items = Object.assign([], this.headers);

        _items.splice(this.movingIndex, 1);
        _items.splice(this.futureIndex, 0, this.movingItem);

        this.headers = _items;
        this.emitUpdateEvent();

        this.futureIndex = null;
        this.movingIndex = null;

        const table = document.querySelector('.table.custom-table');
        const tableHead = table.querySelector('thead');
        this.movingItemRect = {};
        setTimeout(() => {
          this.AddResizerHandle();

          // remove
          this.headers.forEach((headerElement) => {
            const element = tableHead.querySelector(
              `#${headerElement} .hoveritem`
            );
            const elementRect = element.getBoundingClientRect();
            if (
              this.currentMousePosition.x >= elementRect.left &&
              this.currentMousePosition.x <= elementRect.right &&
              this.currentMousePosition.y >= elementRect.top &&
              this.currentMousePosition.y <= elementRect.bottom
            ) {
              if (!element.classList.contains('hover-item'))
                element.classList.add('hover-item');
            } else {
              element.classList.remove('hover-item');
            }
          });
        }, 200);
      }
    },
    startSmoothScroll() {
      const scroll = () => {
        if (!this.isDragging) return;

        const tableWrap = this.$refs[`tableWrapRef${this.tableid}`];
        if (this.scrollDirection === 'left') {
          tableWrap.scrollLeft -= 15;
        } else if (this.scrollDirection === 'right') {
          tableWrap.scrollLeft += 15;
        }

        this.scrollAnimation = requestAnimationFrame(scroll);
      };

      this.scrollAnimation = requestAnimationFrame(scroll);
    },
    setScrollDirection(originalEvent) {
      const tableWrap = this.$refs[`tableWrapRef${this.tableid}`];
      if (!tableWrap) return true;
      const rect = tableWrap.getBoundingClientRect();
      const mouseX = originalEvent.clientX;

      if (mouseX < rect.left + 70) {
        this.scrollDirection = 'left';
      } else if (mouseX > rect.right - 70) {
        this.scrollDirection = 'right';
      } else {
        this.scrollDirection = null;
      }
    },
    handleMove(e) {
      const { index, futureIndex } = e.draggedContext;
      const tempFutureIndex =
        futureIndex === 0 ? e.relatedContext.index : futureIndex;

      const finalMoveIndex =
        this.isCheckBoxEnabled && this.isCheckBoxEnabled === true
          ? index - 1
          : index;
      const finalFutureIndex =
        this.isCheckBoxEnabled && this.isCheckBoxEnabled === true
          ? tempFutureIndex - 1
          : tempFutureIndex;

      this.movingIndex = finalMoveIndex;
      this.futureIndex = finalFutureIndex;
      this.movingItemRect = e.relatedRect;

      return false;
    },
    setWidth(headerId, width) {
      this.$set(this.columnWidth, headerId, width);
    },
    formatValues(val) {
      const datePat = /^[0-9]{4}-[0-9]{2}-[0-9]{2}/gm;
      const datetimePat = /^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}/gm;
      if (Array.isArray(val)) {
        return val.join(', ');
      } else if (datetimePat.test(val)) {
        const date = new Date(val);
        return this.isShowSeconds
          ? date.toLocaleString()
          : date.toLocaleString(undefined, {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            });
      } else if (datePat.test(val)) {
        return new Date(val).toLocaleString().split(',')[0];
      } else if (isObjectType(val)) {
        return val.name;
      } else {
        return val;
      }
    },
    isList: function (val) {
      return Array.isArray(val) && typeof val[0] !== 'string';
    },
    formatDate(value) {
      if (typeof value === 'string')
        return new Date(Number(value))?.toLocaleString();
      else return new Date(value)?.toLocaleString();
    },
    dragEnterHandler(event) {
      const th = event.target.parentElement;
      const div = th.querySelector('.resizeHandle');
      const leftDiv = th.querySelector('.resizeHandle-before');
      const isResizeLineVisible =
        this.headers[this.movingIndex] &&
        th.id !== this.headers[this.movingIndex];
      if (event.clientX < this.startX) {
        if (leftDiv && isResizeLineVisible) {
          leftDiv.style.borderRight = '5px solid #2383e2';
        }

        if (div) {
          div.style.borderRight = '';
        }
      } else {
        if (div && isResizeLineVisible) {
          div.style.borderRight = '5px solid #2383e2';
        }

        if (leftDiv) {
          leftDiv.style.borderRight = '';
        }
      }
    },
    dragLeaveHandler(event) {
      const th = event.target.parentElement;
      const div = th.querySelector('.resizeHandle');
      const leftDiv = th.querySelector('.resizeHandle-before');
      if (div) {
        div.style.borderRight = '';
      }

      if (leftDiv) {
        leftDiv.style.borderRight = '';
      }
    },
    AddResizerHandle() {
      let $vm = this;
      const table = document.getElementById(this.tableid);
      if (table) {
        const resizableColumns = document.querySelectorAll('.draggableitems');

        // const resizerHeight = resizableColumns[0].offsetHeight;

        resizableColumns.forEach((column) => {
          const resizer = column.querySelector('.resizeHandle');

          // eslint-disable-next-line no-unused-vars
          let startX, startWidth, tableWidth, currentHeader;

          resizer.addEventListener('mousedown', (event) => {
            currentHeader = event.target.parentElement;
            startX = event.clientX;
            startWidth = parseInt(getComputedStyle(column).width);
            tableWidth = parseInt(getComputedStyle(column.parentNode).width);

            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
          });

          const handleMouseMove = (event) => {
            if (currentHeader) {
              this.isColumnResizing = true;
              // const table = document.getElementById($vm.tableid);
              let width = startWidth + event.clientX - startX;
              // const newTableWidth = tableWidth + (width - startWidth);
              if (width < 35) {
                return;
              }
              column.style.width = `${width}px`;
              // table.style.width = `${newTableWidth}px`;

              $vm.setWidth(currentHeader.id, width);
              this.$nextTick(() => {
                this.setCreatedColWidth();
              });
            }
          };

          const handleMouseUp = (e) => {
            this.isColumnResizing = false;
            e.stopPropagation();
            $vm.emitUpdateEvent();

            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
          };
        });
      }
    },
    onDocumentClick(event) {
      const tableBody = document.querySelector('.table.custom-table tbody');
      const { isDropDownOpen } = this.isDropDownOpenInContainer();
      if (tableBody) {
        const isClickContainsTableBody = tableBody.contains(event.target);
        if (isDropDownOpen !== null) {
          const parentTr = isDropDownOpen.closest('tr');
          if (parentTr && !isClickContainsTableBody) {
            this.hideActionBar(parentTr);
          }
        }
      }
    },
    AddListenerForActionBar() {
      document.body.addEventListener('click', this.onDocumentClick);
    },
    getRowCheckedClasses(frontItem, currentItem, rearItem) {
      if (this.isCheckboxChecked(currentItem)) {
        if (!frontItem || !this.isCheckboxChecked(frontItem)) {
          if (!rearItem || !this.isCheckboxChecked(rearItem)) {
            return 'isrowchecked';
          } else {
            return 'isrowchecked selected-item-top';
          }
        } else if (!rearItem || !this.isCheckboxChecked(rearItem)) {
          return 'isrowchecked selected-item-bottom';
        } else {
          return 'isrowchecked selected-item-center';
        }
      } else {
        return '';
      }
    },
    getFormatNumber(key) {
      let { data } = this.getObjectData(key, 'formatted_number');
      return {
        thousandseparator: data?.settings?.thSep ?? '.',
        decimalseparator: data?.settings?.decSep ?? ',',
      };
    },
    getListContent(objectList, header = null) {
      let string = '';
      objectList.forEach((item, objectListIndex) => {
        const itemArray = this.getOrderedObjectListEntries(item, header);
        itemArray.forEach(([key, value], index) => {
          const fieldValue = value !== null ? value : '';
          const contentToBeAdded = `${
            header
              ? this.getObjectListLabel(header, key, fieldValue, true, true)
              : `${key}: ${fieldValue} `
          }`;
          if (contentToBeAdded.trim()) {
            string += contentToBeAdded;
            if (
              objectListIndex + 1 !== objectList.length ||
              index + 1 !== itemArray.length
            ) {
              string += ', ';
            }
          }
        });
      });
      return string;
    },
    getOrderedObjectListEntries(item, header = null) {
      const objectItem = item && typeof item === 'object' ? item : {};
      const itemKeys = Object.keys(objectItem);

      if (!header) {
        return itemKeys.sort().map((key) => [key, objectItem[key]]);
      }

      const metadata = this.getObjectData(header, 'objectlist');
      const schemaNames = (metadata?.data?.schema || [])
        .map((field) => field?.name)
        .filter((name) => typeof name === 'string' && name.length > 0);

      const keyOrderMap = new Map(
        schemaNames.map((name, index) => [name, index])
      );
      const orderedKeys = [...itemKeys].sort((a, b) => {
        const aOrder = keyOrderMap.has(a)
          ? keyOrderMap.get(a)
          : Number.MAX_SAFE_INTEGER;
        const bOrder = keyOrderMap.has(b)
          ? keyOrderMap.get(b)
          : Number.MAX_SAFE_INTEGER;
        if (aOrder === bOrder) return a.localeCompare(b);
        return aOrder - bOrder;
      });

      return orderedKeys.map((key) => [key, objectItem[key]]);
    },
    getObjectListFieldType(key, name) {
      const field = this.getObjectListFieldSchema(key, name);
      return field?.type;
    },
    getObjectListFieldSchema(key, name) {
      const metadata = this.getObjectData(key, 'objectlist');
      const schema = metadata?.data?.schema || [];
      return schema.find((data) => data?.name === name);
    },
    getObjectListFormattedValue(
      key,
      name,
      value,
      isDecimalTruncated = false,
      shouldFormatFormattedNumber = false
    ) {
      if (value === null || value === undefined || value === '') {
        return value;
      }

      const field = this.getObjectListFieldSchema(key, name);
      const fieldType = field?.type;
      if (!['number', 'formatted_number'].includes(fieldType)) {
        return value;
      }

      if (fieldType === 'formatted_number') {
        if (!shouldFormatFormattedNumber) {
          return value;
        }
        const thSep = field?.settings?.thSep ?? '.';
        const decSep = field?.settings?.decSep ?? ',';
        const fixed = Number(field?.settings?.toFixed ?? 2);
        const sanitized = String(value)
          .trim()
          .replace(/\s+/g, '')
          .split(thSep)
          .join('')
          .replace(decSep, '.');
        const numericValue = Number(sanitized);
        if (!Number.isFinite(numericValue)) {
          return value;
        }

        const [integerPart, decimalPart = ''] = numericValue
          .toFixed(Number.isFinite(fixed) ? fixed : 2)
          .split('.');
        const formattedIntegerPart = integerPart.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          thSep
        );
        let formattedDecimalPart = decimalPart;
        if (isDecimalTruncated && formattedDecimalPart.length > 3) {
          formattedDecimalPart = `${formattedDecimalPart.slice(0, 3)}...`;
        }
        return formattedDecimalPart
          ? `${formattedIntegerPart}${decSep}${formattedDecimalPart}`
          : formattedIntegerPart;
      }

      const valueString = String(value).trim();
      const decimalMatch = valueString.match(/^(-?\d+)([.,])(\d+)$/);
      if (!decimalMatch) {
        return value;
      }

      const integerPart = decimalMatch[1];
      const separator = decimalMatch[2];
      const decimalPart = decimalMatch[3];

      if (!isDecimalTruncated || decimalPart.length <= 3) {
        return value;
      }

      return `${integerPart}${separator}${decimalPart.slice(0, 3)}...`;
    },
    onMouseEnterOnTableHeader(event) {
      if (!event.target.classList.contains('hover-item'))
        event.target.classList.add('hover-item');
    },
    onMouseLeaveOnTableHeader(event) {
      event.target.classList.remove('hover-item');
    },
    onMouseMove(event) {
      this.currentMousePosition = {
        x: event.x,
        y: event.y,
      };
    },
    getColumnStyle(header) {
      const minWidth = this.isCorrectElementType(header, 'formatted_number')
        ? 60
        : this.getHeader(header).length * 7 + 25;
      let width = this.columnWidth[header]
        ? this.columnWidth[header]
        : minWidth;
      if (width < minWidth) {
        width = minWidth;
      }
      return {
        width: width + 'px',
        'min-width': minWidth + 'px',
      };
    },
    setCreatedColWidth() {
      const el = this.$refs[`tableWrapRef${this.tableid}`];
      if (el) {
        const tableHeader = document.getElementById('table-header-created');
        if (tableHeader) {
          const headerCoordinates = tableHeader.getBoundingClientRect();
          const isOverflowing =
            headerCoordinates.x - headerCoordinates.y > el.clientWidth ||
            el.clientWidth < el.scrollWidth ||
            headerCoordinates.width < 165;
          const el2 = document.getElementById('table-header-created');
          if (!el2) return;
          if (!isOverflowing) {
            el2.style.width = '100%';
          } else {
            el2.style.width = '165px';
          }
        }
      }
    },
    setColumnWidth() {
      const columnsWidth = {};
      const unsetWidthColumns = this.headers.filter(
        (header) => this.columnWidth[header] === undefined
      );
      if (unsetWidthColumns.length) {
        for (let i = 0; i < this.dataList.length; i++) {
          const row = this.dataList[i];
          for (const item of unsetWidthColumns) {
            if (
              this.dataList[i][item] !== undefined &&
              (!columnsWidth.hasOwnProperty(item) ||
                (columnsWidth[item] &&
                  columnsWidth[item] < String(row[item]).length))
            ) {
              if (this.isCorrectElementType(item, 'formatted_number')) {
                const { data } = this.getObjectData(item, 'formatted_number');
                const toFixed = Number(data?.settings?.toFixed ?? 2);
                columnsWidth[item] = row[item]
                  ? row[item].toLocaleString().length + 1 + toFixed
                  : row[item];
              } else if (this.isCorrectElementType(item, 'freecontent')) {
                columnsWidth[item] = 3;
              } else if (this.isCorrectElementType(item, 'timestampms')) {
                columnsWidth[item] = this.formatDate(row[item]).length;
              } else if (this.isList(row[item])) {
                columnsWidth[item] =
                  this.getListContent(row[item]).length <= 36
                    ? this.getListContent(row[item]).length
                    : 36;
              } else {
                columnsWidth[item] = String(
                  this.formatValues(row[item])
                ).length;
              }
            }
          }
        }
        for (const item in columnsWidth) {
          columnsWidth[item] = columnsWidth[item] * 8 + 33;
          this.$set(this.columnWidth, item, columnsWidth[item]);
        }
        this.$emit('onDragOrResize', {
          updatedHeaders: [...this.headers].filter(
            (el) => el !== null && el !== undefined
          ),
          updatedHeadersWidth: { ...this.columnWidth, ...columnsWidth },
        });
      }
    },
    getObjectListLabel(
      key,
      name,
      value,
      returnValue = false,
      isDecimalTruncated = false,
      shouldFormatFormattedNumber = false
    ) {
      const metadata = this.getObjectData(key, 'objectlist');
      const originalValue = value !== null ? value : '';
      const valueToBeShown = this.getObjectListFormattedValue(
        key,
        name,
        originalValue,
        isDecimalTruncated,
        shouldFormatFormattedNumber
      );
      if (metadata?.data?.schema) {
        const findObjectList = metadata.data.schema.find(
          (data) => data.name === name
        );
        if (findObjectList?.label) {
          return returnValue
            ? `${findObjectList.label} : ${valueToBeShown}`
            : `<span>${findObjectList.label}&nbsp;:</span><span class="word-break">${valueToBeShown}</span>`;
        } else {
          return '';
        }
      }
      return returnValue
        ? `${name} : ${valueToBeShown}`
        : `<span>${name}&nbsp;:</span><span class="word-break">${valueToBeShown}</span>`;
    },
    setVirtualScrollData() {
      const tableRow = document.getElementsByClassName('table-row');
      if (tableRow && tableRow[0]) {
        this.virtualScrollData.itemHeight = tableRow[0].offsetHeight;
        this.virtualScrollData.visibleItemsCount = Math.floor(
          this.$refs[`tableWrapRef${this.tableid}`].offsetHeight /
            this.virtualScrollData.itemHeight
        );
        this.virtualScrollData.endIndex =
          this.virtualScrollData.startIndex +
          this.virtualScrollData.visibleItemsCount;
      }
    },
    getDropdownLabel(key, value) {
      const metadata = this.getObjectData(key, 'select');
      if (metadata?.data?.options?.length) {
        const find = metadata.data.options.find(
          (option) => option.value === value
        );
        if (find?.label) {
          return find.label;
        }
      }
      return value;
    },

    getRadioLabel(key, value) {
      const metadata = this.getObjectData(key, 'radio');
      if (metadata?.data?.options?.length) {
        const find = metadata.data.options.find(
          (option) => option.value === value
        );
        if (find?.label) {
          return find.label;
        }
      }
      return value;
    },
    getCheckboxLabel(key, value = []) {
      const metadata = this.getObjectData(key, 'checkbox');
      if (metadata?.data?.options?.length) {
        const find = metadata.data.options
          .filter(
            (option) =>
              value &&
              value.includes(
                option.hasOwnProperty('value') ? option.value : option.label
              )
          )
          .map((option) => option.label);

        return find.toString();
      }
      return value;
    },
    showEditInputField(e, key, value, itemId, type) {
      if (
        this.database.type === 'timetrigger' ||
        this.database.access_level === 'read'
      )
        return;
      const directEditInput = {};
      const fieldTypes = [
        'email',
        'number',
        'date',
        'datetime-local',
        'range',
        'databaseid',
        'model',
        'textarea',
        'smartmessage',
        'radio',
        'status',
        'checkbox',
        'filenew',
        'hidden',
      ];
      if (type) {
        directEditInput.type = type;
      } else {
        for (const field of fieldTypes) {
          if (this.isCorrectElementType(key, field)) {
            directEditInput.type = field;
            break;
          }
        }
      }
      const getMetadata = this.getObjectData(key, directEditInput.type);
      const getCoordinates = e.target.getBoundingClientRect();
      directEditInput.show = true;
      if (value === undefined) {
        directEditInput.currentValue = '';
        directEditInput.oldValue = '';
        if (
          directEditInput.type === 'checkbox' &&
          !Array.isArray(directEditInput.currentValue)
        ) {
          directEditInput.currentValue = [];
          directEditInput.oldValue = [];
        }
      } else {
        directEditInput.currentValue =
          ['radio', 'status'].includes(directEditInput.type) &&
          Array.isArray(value)
            ? structuredClone(value[0])
            : structuredClone(value);
        directEditInput.oldValue =
          ['radio', 'status'].includes(directEditInput.type) &&
          Array.isArray(value)
            ? structuredClone(value[0])
            : structuredClone(value);
      }

      directEditInput.metaData = getMetadata;
      directEditInput.id = itemId;
      directEditInput.uuid = generateUUID();
      const style = {
        left: `${getCoordinates.left - 28}px`,
      };
      let maxHeight;
      if (window.innerHeight - getCoordinates.bottom < 160) {
        style.bottom = `${window.innerHeight - getCoordinates.bottom + 10}px`;
        maxHeight = `${getCoordinates.top}px`;
      } else {
        style.top = `${getCoordinates.top}px`;
        maxHeight = `${window.innerHeight - getCoordinates.bottom}px`;
      }
      if (['select', 'linktodb'].includes(type)) {
        style.minWidth = '180px';
      } else {
        style.overflow = 'auto';
        style.maxHeight = maxHeight;
      }

      if (
        ['text', 'textarea', 'smartmessage'].includes(type) ||
        ['text', 'textarea', 'smartmessage'].includes(getMetadata?.data?.type)
      ) {
        const tableWrapElement = this.$refs[`tableWrapRef${this.tableid}`];
        const tableElementCoord = tableWrapElement.getBoundingClientRect();
        let maxWidth = window.innerWidth - getCoordinates.left;
        if (tableElementCoord.left > getCoordinates.left - 28) {
          style.left = `${tableElementCoord.left}px`;
          maxWidth = window.innerWidth - tableElementCoord.left - 28;
        }
        const editorFieldWidth = getCoordinates.width + 30;
        style.width = `${
          editorFieldWidth < 200
            ? 200
            : editorFieldWidth > maxWidth
            ? maxWidth
            : editorFieldWidth
        }px`;
      }

      directEditInput.style = style;
      this.directEditInput.inputs.push(directEditInput);
      this.setInputFocus(directEditInput.uuid);
    },
    async hideEditInputField(id, errorMessage = null) {
      const findIndex = this.directEditInput.inputs.findIndex(
        (input) => input.uuid === id
      );
      if (findIndex !== -1) {
        if (errorMessage) {
          this.showToaster(errorMessage, 'Fehlerhaft !', 'danger');
          this.directEditInput.inputs[findIndex].show = false;
          return;
        }
        if (this.directEditInput.inputs[findIndex].type === 'checkbox') {
          if (
            this.arraysHaveSameValues(
              this.directEditInput.inputs[findIndex].oldValue || [],
              this.directEditInput.inputs[findIndex].currentValue || []
            )
          ) {
            this.directEditInput.inputs[findIndex].show = false;
            return;
          }
        } else if (this.directEditInput.inputs[findIndex].type === 'filenew') {
          if (
            (this.directEditInput.inputs[findIndex].currentValue === null &&
              this.directEditInput.inputs[findIndex].oldValue === null) ||
            this.directEditInput.inputs[findIndex].oldValue?.created ===
              this.directEditInput.inputs[findIndex].currentValue?.created
          ) {
            this.directEditInput.inputs[findIndex].show = false;
            return;
          }
        } else if (
          this.directEditInput.inputs[findIndex].oldValue ===
          this.directEditInput.inputs[findIndex].currentValue
        ) {
          this.directEditInput.inputs[findIndex].show = false;
          return;
        }
        this.setFieldValue(this.directEditInput.inputs[findIndex]);
        this.directEditInput.inputs[findIndex].show = false;
        try {
          if (this.directEditInput.inputs[findIndex].type === 'filenew') {
            const preSignedUrl = await getPreSignedUrl(
              this.database.name,
              this.directEditInput.inputs[findIndex].currentValue.name
            );
            this.directEditInput.inputs[findIndex].currentValue.link =
              preSignedUrl.signature.key;
            await uploadFile(
              preSignedUrl,
              this.directEditInput.inputs[findIndex].currentValue.files
            );
            delete this.directEditInput.inputs[findIndex].currentValue.files;
          }
          const payload = {
            value: this.directEditInput.inputs[findIndex].currentValue,
          };
          await updateOneItemField(
            this.database.name,
            this.directEditInput.inputs[findIndex].id,
            this.directEditInput.inputs[findIndex].metaData.data.name,
            payload
          );
        } catch (error) {
          this.setFieldValue(this.directEditInput.inputs[findIndex], false);
          this.showToaster(
            'Werte des Feldes werden nicht aktualisiert. Etwas ist schiefgelaufen.',
            'Fehlerhaft !',
            'danger'
          );
        }
      }
    },
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    arraysHaveSameValues(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;
      return arr1?.sort()?.toString() === arr2?.sort()?.toString();
    },
    setFieldValue(directEditInput, isNewValueSet = true) {
      const findIndex = this.dataList.findIndex(
        (index) => index.id === directEditInput.id
      );
      if (findIndex !== -1) {
        this.dataList[findIndex][directEditInput.metaData.data.name] =
          isNewValueSet
            ? directEditInput.currentValue
            : directEditInput.oldValue;
      }
    },
    setInputFocus(itemId) {
      setTimeout(() => {
        const refInput = this.$refs[`direct-edit-input-${itemId}`]?.[0];
        if (refInput?.$refs?.input) {
          refInput.$refs.input.focus();
        } else if (refInput?.$refs?.textarea) {
          refInput.$refs.textarea.focus();
        } else if (refInput?.$refs?.['input-timestampms']) {
          refInput.$refs['input-timestampms'].focus();
        } else if (refInput?.$refs['number-input']?.$el) {
          const numberComponent = refInput.$refs['number-input'].$el;
          const input = numberComponent.querySelector('.number-input');
          input.focus();
        }
      });
    },
    setTableCustomWidth() {
      const tableWrap = this.$refs[`tableWrapRef${this.tableid}`];

      if (tableWrap) {
        this.tableWrapWidth = tableWrap.offsetWidth;
      }
    },
    handleResizeDoubleClick(header) {
      const label = this.getHeader(header);
      const span = document.createElement('span');
      span.style.visibility = 'hidden';
      span.style.fontSize = '14px';
      span.style.fontFamily = 'AktivGroteskMedium';
      span.style.padding = '8px 15px';
      span.textContent = label;
      document.body.appendChild(span);
      const width = span.offsetWidth;
      document.body.removeChild(span);
      this.setWidth(header, width + 3);
      this.$nextTick(() => {
        this.setCreatedColWidth();
      });
    },
    showTextAreaPopup(event, text) {
      if (this.isScrolling || !text || !text.length) {
        this.hideTextAreaPopup();
        return;
      }
      const target = event.currentTarget;
      const rect = target.getBoundingClientRect();

      let left = rect.left;
      let top = rect.bottom + window.scrollY + 5;

      const width = 350;
      const sideNavbar = document.querySelector('.navbar-left-inner');
      const sideNavbarWidth = sideNavbar.offsetWidth;
      if (left + width > window.innerWidth) {
        left = window.innerWidth - width - 36;
      } else if (left - sideNavbarWidth < 0) {
        left = sideNavbarWidth + 54;
      }

      this.textAreaPopup = {
        visible: true,
        text,
        style: {
          top: top + 'px',
          left: left + 'px',
        },
      };
    },
    hideTextAreaPopup() {
      this.textAreaPopup.visible = false;
    },
  },
  computed: {
    ...mapGetters({
      getsidebarLinkedCustomDBSettings: 'getsidebarLinkedCustomDBSettings',
    }),
    getVariableTableHeight() {
      if (this.variableTableHeight) {
        return `calc(100vh - ${this.variableTableHeight}px)`;
      } else {
        return `calc(100vh - 100px)`;
      }
    },
    getVisibleItems() {
      const start = Math.max(0, this.virtualScrollData.startIndex - 3);
      const end = Math.min(
        this.dataList.length,
        this.virtualScrollData.endIndex + 3
      );
      return this.dataList.slice(start, end);
    },

    spacerHeight() {
      const start = Math.max(0, this.virtualScrollData.startIndex - 3);
      const end =
        this.dataList.length -
        Math.min(this.dataList.length, this.virtualScrollData.endIndex + 3);
      return {
        top: start * this.virtualScrollData.itemHeight,
        bottom: end * this.virtualScrollData.itemHeight,
      };
    },
    isEnableDirectEditing() {
      return this.directEditInput.inputs.filter((input) => input.show).length;
    },
    isShowSeconds() {
      return (
        !this.database.hasOwnProperty('showSeconds') ||
        this.database.showSeconds === null ||
        JSON.parse(this.database.showSeconds)
      );
    },
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.onDocumentClick);
    document.body.removeEventListener('mousemove', this.onMouseMove);
    window.removeEventListener('resize', this.setTableCustomWidth);
  },
  created() {
    if (this.getHeaderContent) {
      this.headers = this.dataHeader.filter(
        (header) => this.getHeaderContent[header]
      );
    } else {
      this.headers = this.dataHeader;
    }
  },
  mounted() {
    this.setTableCustomWidth();
    this.setColumnWidth();
    setTimeout(() => {
      this.AddResizerHandle();
      this.AddListenerForActionBar();
      document.body.addEventListener('mousemove', this.onMouseMove);
      this.setCreatedColWidth();
      window.addEventListener('resize', this.setTableCustomWidth);
    }, 1000);
    setTimeout(() => {
      this.setVirtualScrollData();
    }, 0);
  },
  watch: {
    dataHeader: {
      deep: true,
      handler(newval, oldval) {
        this.headers = newval;
        setTimeout(() => {
          this.setCreatedColWidth();
          if (newval && oldval) {
            if (
              newval.length > oldval.length ||
              newval.toString() !== oldval.toString()
            ) {
              this.AddResizerHandle();
            }
          }
        }, 1000);
      },
      immediate: true,
    },
    'dataList.length': {
      handler(newLength, oldLength) {
        setTimeout(() => {
          this.setVirtualScrollData();
          if (oldLength === 0 && newLength > 0) {
            this.AddResizerHandle();
            this.setColumnWidth();
          }
        }, 0);
      },
    },
  },
  components: {
    draggable,
    NumberComponent,
    DirectEditInput,
  },
  emits: ['onDragOrResize', 'onCheckBoxClick'],
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}
.custom-table tbody tr.isrowchecked:hover {
  z-index: 12;
}
tr.table-row:has(.dropdown-menu.show) {
  z-index: 13;
}
.custom-table tr:hover .shadow-div-wrap {
  box-shadow: 2px 2px 10px 2px rgba(0, 0, 0, 0.2);
}
.codelos-custom-list .custom-table tr.isrowchecked td {
  border-top: none !important;
}
.codelos-custom-list .custom-table tr.isrowchecked + tr td {
  border-top: none !important;
}
.shadow-div-wrap {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  padding: 0 !important;
  pointer-events: none;
  border-radius: 5px;
  z-index: 13;
  box-shadow: none;
}
.custom-table
  tbody
  tr.isrowchecked:not(
    .selected-item-top,
    .selected-item-bottom,
    .selected-item-center
  )
  .shadow-div-wrap {
  border: 1px solid #0fbf00;
}
.custom-table tbody tr.isrowchecked.selected-item-center .shadow-div-wrap {
  border: 1px solid #0fbf00;
  border-bottom: 1px solid #dee2e6;
  border-top: 1px solid #dee2e6;
  border-radius: 0;
}
.custom-table tbody tr.isrowchecked.selected-item-top .shadow-div-wrap {
  border: 1px solid #0fbf00;
  border-bottom: 0;
  border-radius: 5px 5px 0 0;
}
.custom-table
  tbody
  tr.isrowchecked.selected-item-top:has(+ .selected-item-bottom) {
  border-bottom: 1px solid #dee2e6;
}
.custom-table tbody tr.isrowchecked.selected-item-bottom .shadow-div-wrap {
  border: 1px solid #0fbf00;
  border-top: 0;
  border-radius: 0 0 5px 5px;
}

.custom-table-wrap .loadingoverlay {
  padding: 0 !important;
}

.row-loader-div {
  display: flex;
  width: 100%;
  height: 100%;
  position: sticky;
  left: 0;
  align-items: center;
}

.custom-table-wrap {
  width: 100%;
  overflow: auto;
  padding: 0 10px 10px 10px;
  overflow-anchor: none;
}

.custom-table {
  border: none;
  margin-bottom: 0;
  table-layout: fixed;
  border-collapse: collapse;
}

.custom-table > thead {
  vertical-align: bottom;
  position: sticky;
  top: 0;
  z-index: 40;
  background: #fff;
}
.custom-table > thead tr {
  left: -2px;
}

.custom-table tr {
  position: relative;
  z-index: auto;
}

.custom-table tbody tr.isrowchecked {
  top: 0px;
  background-color: rgba(220, 220, 220, 0.16);
  z-index: auto;
}

.custom-table tbody .isrowchecked:after {
  content: '';
  display: none;
  position: absolute;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  left: -2px;
  top: -2px;
  box-sizing: border-box;
  border: 2px solid #1fc281;
  border-radius: 5px;
  z-index: -1;
}

/* .custom-table tbody .isrowchecked {
  z-index: 1;
} */

.custom-table-wrap .loadingoverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #1f2532c7;
  z-index: 14;
  text-align: center;
}
.custom-table-wrap .loadingoverlay .custom-table-progress-icon {
  content: ' ';
  display: block;
  width: 30px;
  height: 30px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: progress-icon-animation 1.2s linear infinite;
  margin: 0 auto;
  position: absolute;
  left: 50%;
}

.custom-table-wrap .table > :not(caption) > * > *:not(.loadingoverlay) {
  background-color: transparent !important;
}

@keyframes progress-icon-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.custom-table th {
  background: transparent;
  border-bottom: none !important;
  position: relative;
}

.custom-table .draggableitems {
  cursor: grab;
}

.custom-table th {
  font-size: 14px;
  font-weight: 400;
  padding: 0;
  white-space: nowrap;
}

.custom-table td {
  padding: 9px 15px;
  font-size: 12px;
  vertical-align: middle;
  color: #5f697a;
  border-bottom: none;
  border-left: none;
  /* background: #fff; */
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
}

.custom-table td:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.custom-table td:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.custom-table th:first-child,
.custom-table td:first-child {
  width: 60px;
}

/* .custom-table td:last-child,
.custom-table th:last-child {
  width: 200px;
} */

.custom-table td .table-content {
  /* display: -webkit-box; */
  /* -webkit-line-clamp: 1; */
  /* -webkit-box-orient: vertical; */
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: 'AktivGroteskMedium';
  position: relative;
  z-index: 4;
  min-height: 35px;
}

.custom-table td.table-column-created .table-content {
  text-overflow: unset;
  white-space: nowrap;
}
.custom-table tr:last-child td {
  border-bottom: 1px solid #e7e7e7;
}
.custom-table tr th.check-box,
.custom-table tr td.check-box,
.custom-table th:first-child {
  padding: 0% !important;
  margin: 0% !important;
  min-width: 60px;
  max-width: 60px;
  position: sticky;
  left: -10px;
  z-index: 5;
  border-radius: 0px;
  background: transparent !important;
  box-shadow: 2px 0 0 transparent;
}

.custom-table tr th.check-box .checker,
.custom-table tr td.check-box .checker {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  background-color: white;
  margin-top: 1px;
}
.custom-table tr th.check-box .checker input {
  opacity: 0;
}
.custom-table tr:hover .check-box .checker input {
  opacity: 1;
}
.custom-table tr th.check-box .checker {
  box-shadow: -10px 0 0 #ffffff;
  opacity: 1;
}

.custom-table tr th.check-box input,
.custom-table tr td.check-box input {
  z-index: 10;
}

.custom-table .ghost {
  background: #dfdfdf80;
  color: black;
}
.custom-table .hoveritem {
  display: flex;
  height: 100%;
  padding: 8px 15px;
  transition: all 300ms ease-in-out;
  color: gray;
  font-family: 'AktivGroteskMedium';
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
}

.custom-table .hover-item {
  background: #dfdfdf80;
  color: black;
  transition: all 500ms ease-in-out;
}
.custom-table .checker input,
.custom-table .checker input[type='checkbox'] {
  cursor: pointer;
  visibility: visible;
  height: 16px;
  width: 16px;
  display: inline-block;
  background: 0 0;
  margin-bottom: 0;
  accent-color: #0fbf00;
  margin-right: 0;
  top: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 3px;
  position: relative;
  border: 0.5px solid #a9a9a9;
  box-shadow: -0.5px 0.5px 2px 0.5px #00000024 inset;
}

.custom-table:has(td.check-box .checker input[type='checkbox']:checked)
  thead
  th.check-box
  .checker {
  opacity: 1 !important;
}
.custom-table tr td.check-box .checker:has(input[type='checkbox']:checked) {
  border: 0;
  background-image: linear-gradient(
    to bottom,
    #00000000 0%,
    #00000000 25%,
    #fafafa 25%,
    #fafafa 75%,
    #00000000 75%,
    #00000000 100%
  );
  background-color: transparent;
  opacity: 1;
}

.custom-table .checker input[type='checkbox']:checked {
  background-color: #0fbf00;
}
.custom-table .checker input[type='checkbox']:checked::before {
  content: '';
  position: absolute;
  top: 48%;
  left: 50%;
  width: 9px;
  height: 5px;
  border-left: 2px solid white;
  border-bottom: 2px solid white;
  transform: translate(-50%, -50%) rotate(-45deg);
}

.custom-table .checker input[type='checkbox']:focus-visible {
  outline: none;
}

/* .custom-table tr.hide-action-bar .table-action-tools {
  display: none !important;
} */

/*Action Tools */
/* .custom-table tr:hover .table-action-tools {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
} */
.custom-table .table-action-tools {
  z-index: 13;
  position: fixed;
  top: 233px;
  right: 54px;
  background: #ffff;
  opacity: 0;
  visibility: hidden;
  -webkit-transition: all 200ms ease-in-out;
  transition: all 400ms ease-in-out;
  min-width: 220px;
  /* padding-right: 15px; */
  pointer-events: none;
}
.custom-table tr.isrowchecked .table-action-tools ul {
  background: #f9f9f9;
}
.table-action-tools ul {
  margin: 0;
  padding: 0;
  min-height: 30px;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.table-action-tools ul li {
  margin: 0 2px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-table-wrap .object-list-icon {
  width: 21px;
  height: 21px;
  margin-left: 15px;
}
.custom-table-wrap .object-list-icon {
  width: 21px;
  height: 21px;
}

.resizeHandle {
  position: absolute;
  right: 0;
  top: 0;
  width: 5px;
  cursor: col-resize;
  user-select: none;
  height: 100%;
}

.resizeHandle:hover {
  border-right: 5px solid #2383e2 !important;
}

.resizeHandle-before {
  position: absolute;
  left: 0;
  top: 0;
  width: 5px;
  user-select: none;
  height: 100%;
}

/* custom scroll bar */

.custom-table-wrap::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

.custom-table-wrap.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.custom-table-wrap::-webkit-scrollbar-track {
  background: #ffff;
  border-radius: 10px;
}

.custom-table-wrap::-webkit-scrollbar-thumb {
  background: #555;
  border-radius: 10px;
}

.custom-table-wrap::-webkit-scrollbar-track {
  -webkit-box-shadow: none !important;
  background-color: white;
}
.custom-table thead tr:after {
  content: '';
  position: absolute;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  left: -2px;
  top: -2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 2px solid #f9f9fb;
  border-radius: 4px;
  z-index: -1;
}

.custom-table tr:hover .check-box .checker {
  opacity: 1;
}

@media (max-width: 1300px) {
  .custom-table .table-action-tools {
    right: 43px;
  }
}

@keyframes shadow {
  0% {
    box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.1);
  }
  100% {
    box-shadow: 2px 2px 10px 2px rgba(0, 0, 0, 0.2);
  }
}
.custom-table-wrap .list-content-wrapper {
  display: none;
  position: fixed;
  background: #fff;
  padding: 20px 20px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3);
  z-index: 10050;
  width: 367px;
  border-radius: 6px;
  font-family: 'AktivGroteskMedium';
  font-size: 14px;
  font-weight: 400;
  color: #333343;
  transform: translateX(-20%);
}
.custom-table-wrap .list-scroll {
  padding: 0px 10px;
  max-height: 230px;
  overflow: auto;
}
.custom-table-wrap .list-main {
  z-index: 0;
  position: relative !important;
  /* max-width: 233px; */
  height: 21px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  padding-bottom: 6px !important;
  padding-top: 7px !important;
  font-size: 14px;
  line-height: 36px;
  font-weight: 400;
  color: #333343;
  font-family: 'AktivGroteskMedium';
}
.custom-table-wrap .list-content-wrapper:hover {
  display: block !important;
}
.custom-table-wrap .one-list-wrapper {
  padding: 0px 15px;
}

.custom-table-wrap .list-content-wrapper.list-border .list-content-main {
  border-top: 1px solid #dedede;
  border-bottom: 1px solid #dedede;
  padding: 15px 0px;
}
.custom-table-wrap .list-content {
  display: flex;
  gap: 10px;
  margin: 0px 0px 10px 0px;
}
.custom-table-wrap .list-content ::v-deep span {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  display: block;
}

.custom-table-wrap .list-content ::v-deep span.word-break {
  word-break: break-all;
}
.custom-table-wrap .list-item-td {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
  overflow: visible !important;
  position: relative;
}
.custom-table tr.table-row:has(.list-main:hover),
.custom-table tr.table-row:has(.list-content-wrapper:hover) {
  z-index: 12;
}
.custom-table-wrap .table-column-created {
  overflow: unset !important;
}
.custom-table-wrap #table-header-created {
  width: 100%;
}
.custom-table-wrap .formatted-number-wrapper {
  z-index: 4;
  position: relative;
  min-height: 35px;
  display: flex;
  margin-left: -10px;
  min-width: 0;
  overflow: hidden;
}
.custom-table-wrap .formatted-number-wrapper ::v-deep .number-component {
  width: 100%;
  min-width: 0;
}
.custom-table-wrap
  .formatted-number-wrapper
  ::v-deep
  .number-component-view-wrap {
  min-width: 0;
  width: 100%;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 0;
}

.custom-table-wrap .textarea-popup {
  background: #fff;
  white-space: normal;
  position: fixed;
  padding: 20px;
  z-index: 999;
  width: 350px;
  border-radius: 6px;
  font-family: 'AktivGroteskMedium';
  font-size: 14px;
  font-weight: 400;
  color: #333343;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3);
  animation: fadeIn 0.15s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
